import { useState } from 'react';
import { useLanguage } from '../../../contexts/LanguageContext';

export default function Portfolio() {
  const [selectedProject, setSelectedProject] = useState<number | null>(null);
  const { t, language } = useLanguage();

  const projects = [
    {
      title: {
        pt: 'Especialista Sênior em SIG / Consultor Sênior de Carbono',
        en: 'Senior GIS Specialist / Senior Carbon Advisor'
      },
      company: 'BioCarbon Standards',
      period: {
        pt: 'Brasil | Abril 2025 - Presente',
        en: 'Brazil | April 2025 - Present'
      },
      description: {
        pt: 'Assistência técnica em projetos de três programas: Programa GEE, Programa de Biodiversidade e Programa de Água. Preparação de documentos de avaliação, suporte técnico para registro e certificação de projetos GEE, desenvolvimento de metodologias de quantificação, design de protocolos dMRV, implementação de visualizador geoespacial para projetos.',
        en: 'Technical assistance on projects in three programs: GHG Program, Biodiversity Program, and Water Program. Preparation of evaluation documents, technical support for registration and certification of GHG projects, development of quantification methodologies, design of dMRV protocols, implementation of geospatial viewer for projects.'
      },
      image: 'https://biocarbonstandard.com/wp-content/uploads/biocarbon-og.webp',
      tags: ['GIS', 'Carbon', 'dMRV', 'Biodiversity']
    },
    {
      title: {
        pt: 'Especialista Sênior em SIG / Consultor de Carbono / Consultor de Engajamento',
        en: 'Senior GIS Specialist / Carbon Advisor / Engagement Advisor'
      },
      company: 'Forest Trends',
      period: {
        pt: 'Brasil | Maio 2024 - Presente',
        en: 'Brazil | May 2024 - Present'
      },
      description: {
        pt: 'Preparação de mapas para territórios indígenas e assentamentos, considerando dinâmicas de desmatamento, uso da terra e áreas protegidas. Desenvolvimento de cartilhas sobre Carbono e Mudanças Climáticas, Projetos de Carbono, REDD+, JREDD+, LEAF, CLPI e Repartição de Benefícios. Orientação técnica em propostas de projetos de restauração.',
        en: 'Preparation of maps for indigenous territories and settlements, considering deforestation dynamics, land use and protected areas. Development of booklets on Carbon and Climate Change, Carbon Projects, REDD+, JREDD+, LEAF, CLPI and Benefit Sharing. Technical guidance on restoration project proposals.'
      },
      image: 'https://assets.weforum.org/article/image/3kLI0AJrCoS0vQj5j9lBet1QqlG6qmsRu9qMzIWOFDc.jpg',
      tags: ['GIS', 'REDD+', 'CLPI', 'Restoration']
    },
    {
      title: {
        pt: 'Especialista Sênior em SIG / Consultor Sênior de Carbono / Consultor de Engajamento',
        en: 'Senior GIS Specialist / Senior Carbon Advisor / Engagement Advisor'
      },
      company: 'MAPA / GOPA / OCT',
      period: {
        pt: 'Brasil | Junho 2024 - Maio 2025',
        en: 'Brazil | June 2024 - May 2025'
      },
      description: {
        pt: 'Avaliação de limitações do sistema TerraClass para classificação de uso da terra. Estruturação de fluxos de trabalho e protocolos de validação. Coleta e processamento de dados geoespaciais de fontes como INPE, IBGE e MapBiomas. Mapeamento de rotas de transporte e instalações de armazenamento de grãos na Amazônia Legal.',
        en: 'Evaluation of TerraClass system limitations for land use classification. Structuring workflows and validation protocols. Collection and processing of geospatial data from sources like INPE, IBGE and MapBiomas. Mapping transportation routes and grain storage facilities in Legal Amazon.'
      },
      image: 'https://dados.gov.br/api/publico/s3/ae97ab39-5c89-4446-a6e3-91c0e05a5712.png',
      tags: ['TerraClass', 'MapBiomas', 'Amazon', 'GIS']
    },
    {
      title: {
        pt: 'Consultor em Especialista SIG/SR e Consultor Sênior de PDD',
        en: 'Consultant in GIS/RS Specialist and PDD Senior Advisor'
      },
      company: 'Governo do Estado do Pará / IPAM',
      period: {
        pt: 'Brasil | Junho 2024 - Setembro 2024',
        en: 'Brazil | June 2024 - September 2024'
      },
      description: {
        pt: 'Coleta e processamento de dados geoespaciais e socioambientais para análises temporais e espaciais de dinâmicas de desmatamento. Análise de acurácia de dados de atividade (desmatamento e degradação florestal). Cálculo de propagação de incerteza usando simulações Monte Carlo. Suporte na preparação do Documento de Registro para o estado do Pará em conformidade com o padrão ART/TREES.',
        en: 'Collection and processing of geospatial and socioenvironmental data for temporal and spatial analyses of deforestation dynamics. Accuracy analysis of activity data (deforestation and forest degradation). Calculation of uncertainty propagation using Monte Carlo simulations. Supporting preparation of Registration Document for state of Pará in compliance with ART/TREES standard.'
      },
      image: 'https://i1.wp.com/ipam.org.br/wp-content/uploads/2023/01/logo-ipam-news-980x620.jpg',
      tags: ['ART/TREES', 'Monte Carlo', 'Deforestation', 'IPAM']
    },
    {
      title: {
        pt: 'Consultor em Especialista SIG/SR',
        en: 'Consultant in GIS/RS Specialist'
      },
      company: 'IDESAM',
      period: {
        pt: 'Brasil | Março 2024 - Julho 2024',
        en: 'Brazil | March 2024 - July 2024'
      },
      description: {
        pt: 'Preparação de mapas para território, considerando dinâmicas de desmatamento, uso da terra, áreas protegidas, topografia, hidrografia, redes rodoviárias e ferroviárias. Monitoramento do impacto de projetos IDESAM medindo taxa de desmatamento, juntamente com análise de políticas e econômica.',
        en: 'Preparation of maps for territory, considering deforestation dynamics, land use, protected areas, topography, hydrography, road and railway networks. Monitoring impact of IDESAM projects by measuring deforestation rate, alongside policy and economic analysis.'
      },
      image: 'https://biodev.eco.br/itens/reddcafe-site.png',
      tags: ['IDESAM', 'Monitoring', 'Deforestation', 'GIS']
    },
    {
      title: {
        pt: 'Consultor em Especialista SIG/SR',
        en: 'Consultant in GIS/RS Specialist'
      },
      company: 'SIMEX',
      period: {
        pt: 'Brasil | Agosto 2023 - Julho 2024',
        en: 'Brazil | August 2023 - July 2024'
      },
      description: {
        pt: 'Análise espacial da degradação da Floresta Amazônica através de algoritmos do Google Earth Engine. Classificação de imagens e vetorização de extração ilegal de madeira, incêndios florestais e degradação dos estados do Amazonas e Roraima. Compilação e sistematização de base cartográfica de uso da terra dos sistemas CAR e SIGEF.',
        en: 'Spatial analysis of Amazon Forest degradation through Google Earth Engine algorithms. Imagery classification and vectorization of illegal logging, wildfires, and degradation of Amazonas and Roraima State. Compilation and systematization of land use cartographic base from CAR and SIGEF systems.'
      },
      image: 'https://imazongeo.org.br/wp-content/uploads/2024/07/SIMEX_destaque_1.jpg',
      tags: ['Google Earth Engine', 'SIMEX', 'Amazon', 'Degradation']
    },
    {
      title: {
        pt: 'Diretor de Carbono',
        en: 'Carbon Director'
      },
      company: 'AmaGroup',
      period: {
        pt: 'Brasil | Maio 2022 - Abril 2024',
        en: 'Brazil | May 2022 - April 2024'
      },
      description: {
        pt: 'Preparação de análise de carbono. Monitoramento do impacto de projetos AMAGROUP medindo taxa de desmatamento, análise de biodiversidade, juntamente com análise de políticas e econômica. Análise espacial da degradação da Floresta Amazônica através de algoritmos do Google Earth Engine. Preparação de engajamento de partes interessadas com compromissos e estratégias.',
        en: 'Preparation of carbon analysis. Monitoring impact of AMAGROUP projects by measuring deforestation rate, biodiversity analysis, alongside policy and economic analysis. Spatial analysis of Amazon Forest degradation through Google Earth Engine algorithms. Preparation of stakeholder engagement with appointments and strategies.'
      },
      image: 'https://static.wixstatic.com/media/a9cbf5_588eec4c7e4147968be3eb4fd9e1b8c7~mv2.png/v1/fill/w_205,h_205,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/6.png',
      tags: ['Carbon', 'Biodiversity', 'Stakeholder', 'GEE']
    },
    {
      title: {
        pt: 'Consultor em Especialista SIG/SR e Consultor Sênior de Biologia',
        en: 'Consultant in GIS/RS Specialist and Biologist Senior Advisor'
      },
      company: 'IUCN / CPI ACRE',
      period: {
        pt: 'Brasil | Junho 2021 - Setembro 2021',
        en: 'Brazil | June 2021 - September 2021'
      },
      description: {
        pt: 'Análise de dados tabulares e espaciais como analista da IUCN para o programa de Agentes Agroflorestais Indígenas. Design e implementação de protocolos de monitoramento participativo. Treinamento de agentes agroflorestais indígenas para coletar e relatar dados de biodiversidade usando ferramentas móveis e plataformas GIS.',
        en: 'Analyzed tabular and spatial data as IUCN analyst for Indigenous Agroforestry Agents program. Designed and implemented participatory monitoring protocols. Training Indigenous agroforestry agents to collect and report biodiversity data using mobile tools and GIS platforms.'
      },
      image: 'https://biodev.eco.br/itens/cpiacre-site.png',
      tags: ['IUCN', 'Indigenous', 'Biodiversity', 'Monitoring']
    },
    {
      title: {
        pt: 'Consultor em Design de PDD e Especialista SIG/SR',
        en: 'Consultant in PDD Design and GIS/RS Specialist'
      },
      company: 'IDESAM',
      period: {
        pt: 'Brasil | Maio 2021 - Maio 2022',
        en: 'Brazil | May 2021 - May 2022'
      },
      description: {
        pt: 'Preparação de mapas para território no projeto REDD CAFÉ APUI. Monitoramento do impacto de projetos IDESAM medindo taxa de desmatamento, juntamente com análise de políticas e econômica.',
        en: 'Preparation of maps for territory in REDD CAFÉ APUI project. Monitoring impact of IDESAM projects by measuring deforestation rate, alongside policy and economic analysis.'
      },
      image: 'https://biodev.eco.br/itens/reddcafe-site.png',
      tags: ['REDD+', 'IDESAM', 'PDD', 'GIS']
    },
    {
      title: {
        pt: 'Pesquisador Consultor',
        en: 'Consultant Researcher'
      },
      company: 'GIZ',
      period: {
        pt: 'Brasil | Janeiro 2021 - Maio 2021',
        en: 'Brazil | January 2021 - May 2021'
      },
      description: {
        pt: 'Estruturação de base cartográfica no sul da Bahia. Preparação de mapas para território. Monitoramento do impacto de projetos IDESAM medindo taxa de desmatamento, juntamente com análise de políticas e econômica.',
        en: 'Structuring cartographic base in Southern Bahia. Preparation of maps for territory. Monitoring impact of IDESAM projects by measuring deforestation rate, alongside policy and economic analysis.'
      },
      image: 'https://www.giz.de/themes/custom/dreist/build/giz-logo-with-claim.svg',
      tags: ['GIZ', 'Bahia', 'Cartography', 'Monitoring']
    },
    {
      title: {
        pt: 'Pesquisador Consultor – Especialista SIG',
        en: 'Consultant Researcher – GIS Specialist'
      },
      company: 'SDS/AM',
      period: {
        pt: 'Brasil | Dezembro 2020 - Maio 2021',
        en: 'Brazil | December 2020 - May 2021'
      },
      description: {
        pt: 'Classificação de imagens e vetorização de extração ilegal de madeira, incêndios florestais e degradação da região do Rio Negro, Amazonas. Compilação e sistematização de base cartográfica de uso da terra dos sistemas CAR e SIGEF. Sistematização e preparação de relatório final sobre status de desmatamento de 2016 a 2020.',
        en: 'Imagery classification and vectorization of illegal logging, wildfires and degradation of Rio Negro region, Amazonas. Compilation and systematization of land use cartographic base from CAR and SIGEF systems. Systematization and preparation of final report on deforestation status from 2016 to 2020.'
      },
      image: 'https://apstatic.prodam.am.gov.br/images/logo_governo/logo-gov-horizontal-contraste.svg',
      tags: ['SDS/AM', 'Rio Negro', 'Deforestation', 'CAR']
    },
    {
      title: {
        pt: 'Pesquisador Consultor',
        en: 'Consultant Researcher'
      },
      company: 'Serviço Florestal Brasileiro / NIRAS',
      period: {
        pt: 'Brasil | Setembro 2020 - Maio 2021',
        en: 'Brazil | September 2020 - May 2021'
      },
      description: {
        pt: 'Análise econômica e modelagem para avaliar viabilidade de geração de energia através do uso de resíduos de madeira industrial.',
        en: 'Economic analysis and modeling to evaluate feasibility of energy generation through use of industrial lumber residues.'
      },
      image: 'https://biodev.eco.br/itens/ameacar-site.png',
      tags: ['Economic Analysis', 'Energy', 'Biomass', 'Modeling']
    },
    {
      title: {
        pt: 'Pesquisador Consultor Especialista SIG/SR',
        en: 'Consultant Researcher GIS/RS Specialist'
      },
      company: 'SIMEX',
      period: {
        pt: 'Brasil | Agosto 2020 - Junho 2021',
        en: 'Brazil | August 2020 - June 2021'
      },
      description: {
        pt: 'Análise espacial da degradação da Floresta Amazônica através de algoritmos do Google Earth Engine.',
        en: 'Spatial analysis of Amazon Forest degradation through Google Earth Engine algorithms.'
      },
      image: 'https://imazongeo.org.br/wp-content/uploads/2024/07/SIMEX_destaque_1.jpg',
      tags: ['Google Earth Engine', 'SIMEX', 'Degradation', 'Amazon']
    },
    {
      title: {
        pt: 'Pesquisador Consultor',
        en: 'Consultant Researcher'
      },
      company: 'UNICAMP',
      period: {
        pt: 'Brasil | Janeiro 2021',
        en: 'Brazil | January 2021'
      },
      description: {
        pt: 'Assistente de pesquisa em pesquisa de doutorado, auxiliando em análise GIS de desmatamento usando banco de dados CAR. Foco em: Impactos da Segurança Fundiária no Desmatamento: Evidências da Amazônia Brasileira.',
        en: 'Research assistant in doctoral research, assisting in GIS analysis of deforestation using CAR database. Focus on: Impacts of Tenure Security in Deforestation: Evidence from the Brazilian Amazon.'
      },
      image: 'https://unicamp.br/wp-content/themes/bx-unicamp-multisite/assets/img/logo-unicamp.svg',
      tags: ['UNICAMP', 'Research', 'CAR', 'Tenure']
    },
    {
      title: {
        pt: 'Pesquisador Consultor – Especialista SIG/SR',
        en: 'Consultant Researcher – GIS/RS Specialist'
      },
      company: 'BRCARBON / GEOWIKI',
      period: {
        pt: 'Brasil | Outubro 2020 - Janeiro 2021',
        en: 'Brazil | October 2020 - January 2021'
      },
      description: {
        pt: 'Gestão de dados cartográficos e análise espacial de estradas ilegais, desmatamento, degradação da terra. Aquisição de Carbono Florestal na região sul do Amazonas.',
        en: 'Cartographic data management and spatial analysis of illegal roads, deforestation, land degradation. Acquisition of Forest Carbon in southern Amazonas region.'
      },
      image: 'https://biodev.eco.br/itens/mc-valid-site.png',
      tags: ['Carbon', 'BRCARBON', 'Illegal Roads', 'GIS']
    },
    {
      title: {
        pt: 'Pesquisador Consultor',
        en: 'Consultant Researcher'
      },
      company: 'GIZ',
      period: {
        pt: 'Brasil | Junho 2020 - Agosto 2020',
        en: 'Brazil | June 2020 - August 2020'
      },
      description: {
        pt: 'Forneceu suporte técnico para projeto de pesquisa sobre qualificação profissional em setores de bioeconomia.',
        en: 'Provided technical support for research project on professional qualification in bio economy sectors.'
      },
      image: 'https://biodev.eco.br/itens/exoticas-site.png',
      tags: ['GIZ', 'Bioeconomy', 'Research', 'Training']
    },
    {
      title: {
        pt: 'Consultor em Especialista SIG/SR',
        en: 'Consultant in GIS/RS Specialist'
      },
      company: 'IDESAM',
      period: {
        pt: 'Brasil | Maio 2020 - Junho 2021',
        en: 'Brazil | May 2020 - June 2021'
      },
      description: {
        pt: 'Monitoramento do impacto de projetos IDESAM medindo taxa de desmatamento, juntamente com análise de políticas e econômica.',
        en: 'Monitoring impact of IDESAM projects by measuring deforestation rate, alongside policy and economic analysis.'
      },
      image: 'https://biodev.eco.br/itens/reddcafe-site.png',
      tags: ['IDESAM', 'Monitoring', 'Policy Analysis', 'GIS']
    },
    {
      title: {
        pt: 'Gerente de Espaço / Pesquisador Sênior',
        en: 'Space Manager / Senior Researcher'
      },
      company: 'FVA',
      period: {
        pt: 'Brasil | Março 2018 - Setembro 2018',
        en: 'Brazil | March 2018 - September 2018'
      },
      description: {
        pt: 'Pesquisa sobre uso de recursos naturais das principais cadeias de custódia de Manaus, relacionadas à expansão do agronegócio e construção civil.',
        en: 'Research on use of natural resources of Manaus main custody chains, related to expansion of agribusiness and civil construction.'
      },
      image: 'https://biodev.eco.br/itens/usinassc-site.png',
      tags: ['FVA', 'Natural Resources', 'Manaus', 'Research']
    },
    {
      title: {
        pt: 'Chefe / Gerente de Áreas Protegidas / Presidente do Conselho Consultivo do Mosaico',
        en: 'Head / Manager of Protected Areas / Chairman of Mosaic Advisory Council'
      },
      company: 'SDS/AM',
      period: {
        pt: 'Brasil | Fevereiro 2013 - Março 2018',
        en: 'Brazil | February 2013 - March 2018'
      },
      description: {
        pt: 'Preparação do plano de manejo da reserva do Rio Negro. Acompanhamento de planos de manejo de madeira. Preparação de discussões para acordos de pesca. Estudo de viabilidade para programa PES (Pagamento por serviços ambientais) no Rio Negro (desmatamento evitado). Preparação de projetos para financiamento, recursos para geração de renda, formação de novas lideranças, extensão rural.',
        en: 'Preparation of Rio Negro reserve management plan. Follow-up of wood handling plans. Preparation of discussions for fisheries agreements. Feasibility study for PES (Payment for environmental services) program in Rio Negro (avoided deforestation). Preparation of projects for funding, resourcing for income generation, formation of new leadership, rural extension.'
      },
      image: 'https://biodev.eco.br/itens/ameacar-site.png',
      tags: ['Protected Areas', 'PES', 'Rio Negro', 'Management']
    },
    {
      title: {
        pt: 'Consultor (Designer de Projeto)',
        en: 'Consultant (Project Designer)'
      },
      company: 'Conservation International / Imazon / GSS',
      period: {
        pt: 'Brasil | Junho 2010 - Dezembro 2011',
        en: 'Brazil | June 2010 - December 2011'
      },
      description: {
        pt: 'Designer de projeto REDD na Floresta de Faro, Pará.',
        en: 'Designer of REDD project in Faro Forest, Pará.'
      },
      image: 'https://biodev.eco.br/itens/splinkr-site.png',
      tags: ['REDD', 'Conservation International', 'Pará', 'Design']
    },
    {
      title: {
        pt: 'Consultor Técnico (Designer de Projeto)',
        en: 'Technical Consultant (Project Designer)'
      },
      company: 'Conservation International',
      period: {
        pt: 'Brasil | Dezembro 2010 - Dezembro 2011',
        en: 'Brazil | December 2010 - December 2011'
      },
      description: {
        pt: 'PIN (Nota de Ideia de Projeto) Extremo Oeste da Bahia. Gestão de dados cartográficos e análise espacial. Desenvolvimento metodológico para avaliação e monitoramento de estoques de carbono, desmatamento e prevenção de emissões de CO₂. Modelagem de dinâmicas de desmatamento e recursos hídricos. Metodologia de engajamento de partes interessadas.',
        en: 'PIN (Project Idea Note) Far Western Bahia. Cartographic data management and spatial analysis. Methodological development for evaluation and monitoring of carbon stocks, deforestation and avoidance of CO₂ emissions. Modeling dynamics of deforestation and water resources. Stakeholder engagement methodology.'
      },
      image: 'https://biodev.eco.br/itens/cpiacre-site.png',
      tags: ['PIN', 'Carbon', 'Bahia', 'Methodology']
    },
    {
      title: {
        pt: 'Consultor Técnico (Designer de Projeto)',
        en: 'Technical Consultant (Project Designer)'
      },
      company: 'Winrock International',
      period: {
        pt: 'Brasil / EUA | Março 2011 - Abril 2011',
        en: 'Brazil / USA | March 2011 - April 2011'
      },
      description: {
        pt: 'Avaliação de viabilidade técnica e econômica de projeto pré-REDD no Pará. Gestão de banco de dados cartográfico. Análise comparativa de metodologias VCS. Aplicação da ferramenta VMD0007. Entrega de relatório sistematizado e mapa base usado de acordo com critérios VCS.',
        en: 'Evaluation of technical and economic feasibility of pre-REDD project in Pará. Managing cartographic database. Comparative analysis of VCS methodologies. Application of tool VMD0007. Report delivery systematized and basemap used in accordance with VCS criteria.'
      },
      image: 'https://biodev.eco.br/itens/mc-valid-site.png',
      tags: ['Winrock', 'VCS', 'REDD', 'Feasibility']
    },
    {
      title: {
        pt: 'Pesquisador de Campo e Analista Especialista SIG/SR',
        en: 'Field Researcher and Analyst GIS/RS Specialist'
      },
      company: 'Greenpeace',
      period: {
        pt: 'Brasil | Julho 2009 - Fevereiro 2013',
        en: 'Brazil | July 2009 - February 2013'
      },
      description: {
        pt: 'Análise espacial e avaliação de uso da terra usando MODIS, LS e Spot. "Mapeamento participativo" de uso da terra em Santarém e Belterra (PA), envolvimento com comunidade local e sindicatos locais.',
        en: 'Spatial analysis and land use evaluation using MODIS, LS and Spot. "Participatory mapping" of land use in Santarém and Belterra (PA), involvement with local community and local unions.'
      },
      image: 'https://biodev.eco.br/itens/exoticas-site.png',
      tags: ['Greenpeace', 'Participatory Mapping', 'MODIS', 'Community']
    },
    {
      title: {
        pt: 'Consultor (Designer de Projeto)',
        en: 'Consultant (Project Designer)'
      },
      company: 'CO2X',
      period: {
        pt: 'Brasil | Julho 2010 - Agosto 2010',
        en: 'Brazil | July 2010 - August 2010'
      },
      description: {
        pt: 'Análise técnica e avaliação de viabilidade econômica de projeto REDD em áreas ao longo do rio Guariba.',
        en: 'Technical analysis and evaluation of economic viability of REDD project in areas along Guariba river.'
      },
      image: 'https://biodev.eco.br/itens/usinassc-site.png',
      tags: ['REDD', 'Economic Analysis', 'Guariba', 'CO2X']
    },
    {
      title: {
        pt: 'Consultor Especialista SIG/SR',
        en: 'Consultant GIS/RS Specialist'
      },
      company: 'Acquaplan',
      period: {
        pt: 'Brasil | Julho 2010 - Setembro 2010',
        en: 'Brazil | July 2010 - September 2010'
      },
      description: {
        pt: 'Desenvolvimento de metodologia para mapeamento de vegetação submersa, suportes de palito para identificar áreas de águas rasas.',
        en: 'Development of methodology for mapping submerged vegetation, toothpick holders to identify areas of shallow water.'
      },
      image: 'https://biodev.eco.br/itens/ameacar-site.png',
      tags: ['Acquaplan', 'Methodology', 'Vegetation', 'Mapping']
    },
    {
      title: {
        pt: 'Trabalhador de Campo / Pesquisador / Analista GIS',
        en: 'Field Worker / Researcher / GIS Analyst'
      },
      company: 'Triton Logging Inc. - CANADA',
      period: {
        pt: 'Brasil / Venezuela / Paraguai / Equador | Janeiro 2009 - Julho 2009',
        en: 'Brazil / Venezuela / Paraguay / Ecuador | January 2009 - July 2009'
      },
      description: {
        pt: 'Estudos qualitativos e quantitativos de vegetação Atlântica e Amazônica (mapas e relatórios) de 10 grandes usinas hidrelétricas brasileiras. Inventário florestal e socioeconômico.',
        en: 'Qualitative and quantitative studies of Atlantic and Amazonian vegetation (maps and reports) of 10 large Brazilian hydropower stations. Forest and socioeconomic inventory.'
      },
      image: 'https://biodev.eco.br/itens/reddcafe-site.png',
      tags: ['Triton', 'Hydropower', 'Inventory', 'Vegetation']
    },
    {
      title: {
        pt: 'Consultor e Pesquisador',
        en: 'Consultant and Researcher'
      },
      company: 'YBI Consulting Environment',
      period: {
        pt: 'Brasil | Junho 2007 - Julho 2009',
        en: 'Brazil | June 2007 - July 2009'
      },
      description: {
        pt: 'Vários estudos ambientais para licenciamento ambiental de condomínios. Responsabilidades por elementos GIS e SR, bem como relatórios de remoção de vegetação. Mais de 15 artigos completos (Mapeamento e Relatórios). Mapas de uso de capacidade e cobertura da terra, fragilidade ambiental, árvores isoladas, ocupação e intervenção em APP.',
        en: 'Various environmental studies for environmental licensing of condominiums. Responsibilities for GIS and RS elements as well as vegetation removal reports. More than 15 full papers (Mapping and Reporting). Maps of capacity use and land cover, environmental fragility, isolated trees, occupation and intervention in APP.'
      },
      image: 'https://biodev.eco.br/itens/splinkr-site.png',
      tags: ['Environmental Licensing', 'YBI', 'Mapping', 'Reports']
    },
    {
      title: {
        pt: 'Pesquisador de Campo e Analista Especialista SIG/SR',
        en: 'Field Researcher and Analyst GIS/RS Specialist'
      },
      company: 'Triton Logging Inc. - CANADA',
      period: {
        pt: 'Brasil / Venezuela / Paraguai / Equador | Novembro 2007 - Dezembro 2008',
        en: 'Brazil / Venezuela / Paraguay / Ecuador | November 2007 - December 2008'
      },
      description: {
        pt: 'Análise espacial de vegetação submersa usando imagens Landsat antes da inundação. Mistura espectral (Radarsat - Landsat) e relatórios técnicos para barragens: Balbina, Samuel, Manso, Nova Ponte, Itaipu, Tucuruí, Salto Segredo, Salto Caxias, Petit Saut, Salto Santiago, Foz da Areia, Salto Osório.',
        en: 'Spatial analysis of submerged vegetation using Landsat images prior to flooding. Spectral mixture (Radarsat - Landsat) and technical reports for dams: Balbina, Samuel, Manso, Nova Ponte, Itaipu, Tucurui, Salto Segredo, Salto Caxias, Petit Saut, Salto Santiago, Foz da Areia, Salto Osório.'
      },
      image: 'https://www.androidpolice.com/wp-content/uploads/2016/06/nexus2cee_Screen-Shot-2016-06-23-at-3.31.37-PM.jpg',
      tags: ['Triton', 'Dams', 'Landsat', 'Radarsat']
    },
    {
      title: {
        pt: 'Consultor Técnico Especialista SIG/SR',
        en: 'Technical Consultant GIS/RS Specialist'
      },
      company: 'IDESAM',
      period: {
        pt: 'Brasil | Junho 2007 - Dezembro 2007',
        en: 'Brazil | June 2007 - December 2007'
      },
      description: {
        pt: 'O Projeto da Reserva de Desenvolvimento Sustentável Juma: Reduzindo Emissões de Gases de Efeito Estufa do Desmatamento. Elaboração e sistematização de todo o mapeamento base do Sistema de Informação Geográfica usado na modelagem. Elaboração de mapas de uso da terra (anos 1984, 1995 e 2007).',
        en: 'The Juma Sustainable Development Reserve Project: Reducing Greenhouse Gas Emissions from Deforestation. Elaboration and systematization of all base mapping of Geographic Information System used in modeling. Elaboration of land use maps (years 1984, 1995 and 2007).'
      },
      image: 'https://amazonasatual.com.br/wp-content/uploads/2016/10/JUMA.jpg',
      tags: ['Juma', 'REDD', 'GHG', 'IDESAM']
    },
    {
      title: {
        pt: 'Consultor',
        en: 'Consultant'
      },
      company: 'AES Tietê SP / SC Unis Consulting',
      period: {
        pt: 'Brasil | Novembro 2006 - Junho 2007',
        en: 'Brazil | November 2006 - June 2007'
      },
      description: {
        pt: 'Colaborando no design do Projeto MDL-F/R-DCP pela AES Tietê para reflorestar 13.939 ha. Eleição de áreas para uso, visitas de campo usando imagens de alta resolução IKONOS (0,5 m). Inventários florestais para conhecimento florístico das barragens de Barra Bonita e Água Vermelha. Coordenação de estudos técnicos de campo para compreensão da dinâmica de ocupação humana.',
        en: 'Collaborating in design of MDL-F/R-DCP Project by AES Tietê to reforest 13,939 ha. Election of areas for use, field visits using high-resolution imagery IKONOS (0.5 m). Forest inventories for floristic knowledge of Barra Bonita dams and Red Water. Coordination of technical field studies for understanding dynamics of human occupation.'
      },
      image: 'https://barrabonita.sp.gov.br/storage/turismo/pontos-turisticos/LGkselpyfj.jpg',
      tags: ['CDM', 'Reforestation', 'AES Tietê', 'IKONOS']
    },
    {
      title: {
        pt: 'Analista Ambiental de Campo',
        en: 'Field Environmental Analyst'
      },
      company: 'Cosmos Engineering',
      period: {
        pt: 'Brasil | Junho 2005 - Novembro 2006',
        en: 'Brazil | June 2005 - November 2006'
      },
      description: {
        pt: 'Coordenação de mapeamento, estudos de campo e roteiro para caracterização de diferentes empreendimentos para COELBA, Alphaville & Nestlé.',
        en: 'Coordination of mapping, field studies and roadmap for characterization of different enterprises for COELBA, Alphaville & Nestle.'
      },
      image: 'https://www.androidpolice.com/wp-content/uploads/2016/06/nexus2cee_Screen-Shot-2016-06-23-at-3.31.37-PM.jpg',
      tags: ['Cosmos', 'Field Studies', 'Mapping', 'Coordination']
    },
    {
      title: {
        pt: 'Pesquisador de Campo PROCAVERNA / PREVFOGO',
        en: 'Field Researcher PROCAVERNA / PREVFOGO'
      },
      company: 'IBAMA',
      period: {
        pt: 'Brasil | Junho 2004 - Maio 2005',
        en: 'Brazil | June 2004 - May 2005'
      },
      description: {
        pt: 'Georreferenciamento e caracterização de fazendas em conflito com limites físicos do Parque Nacional da Chapada Diamantina.',
        en: 'Georeferencing and characterization of farms in conflict with physical limits of National Park of Chapada Diamantina.'
      },
      image: 'http://photos.wikimapia.org/p/00/03/51/53/51_full.jpg',
      tags: ['IBAMA', 'Georeferencing', 'Chapada Diamantina', 'Protected Areas']
    }
  ];

  return (
    <section id="portfolio" className="py-24 px-6">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <div className="flex items-center justify-center gap-2 mb-4">
            <div className="w-2 h-2 rounded-full bg-[#ff6b4a]"></div>
            <span className="text-[#f5f1e8]/70 text-sm font-medium uppercase tracking-wider">
              {language === 'pt' ? 'Experiência Profissional' : 'Professional Experience'}
            </span>
          </div>
          <h2 className="text-4xl lg:text-5xl font-serif font-bold text-white mb-4">
            {language === 'pt' ? 'Projetos Desenvolvidos' : 'Developed Projects'}
          </h2>
          <p className="text-[#f5f1e8]/70 text-lg max-w-2xl mx-auto">
            {language === 'pt' 
              ? 'Mais de 15 anos de experiência em consultoria ambiental, análise geoespacial e projetos de carbono' 
              : 'Over 15 years of experience in environmental consulting, geospatial analysis and carbon projects'}
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {projects.map((project, index) => (
            <div 
              key={index}
              className="group relative rounded-2xl overflow-hidden cursor-pointer transition-all duration-300 hover:scale-105 bg-[#1a4d2e]/30 backdrop-blur-sm border border-white/10"
              onClick={() => setSelectedProject(index)}
            >
              <div className="relative h-48 w-full">
                <img 
                  src={project.image}
                  alt={project.title[language]}
                  className="w-full h-full object-cover object-top"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/50 to-transparent"></div>
              </div>
              
              <div className="p-6">
                <div className="flex items-center gap-2 mb-3 flex-wrap">
                  <span className="px-3 py-1 bg-[#ff6b4a] text-white text-xs font-medium rounded-full whitespace-nowrap">
                    {project.company}
                  </span>
                </div>
                <h3 className="text-lg font-bold text-white mb-2 line-clamp-2">{project.title[language]}</h3>
                <p className="text-[#f5f1e8]/70 text-sm mb-3">{project.period[language]}</p>
                <div className="flex flex-wrap gap-2">
                  {project.tags.slice(0, 3).map((tag, tagIndex) => (
                    <span key={tagIndex} className="px-2 py-1 bg-white/10 text-[#f5f1e8]/80 text-xs rounded-md">
                      {tag}
                    </span>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>

        {selectedProject !== null && (
          <div 
            className="fixed inset-0 bg-black/80 backdrop-blur-sm z-50 flex items-center justify-center p-6"
            onClick={() => setSelectedProject(null)}
          >
            <div 
              className="bg-[#1a4d2e] rounded-3xl max-w-4xl w-full max-h-[90vh] overflow-y-auto"
              onClick={(e) => e.stopPropagation()}
            >
              <div className="relative h-64 w-full">
                <img 
                  src={projects[selectedProject].image}
                  alt={projects[selectedProject].title[language]}
                  className="w-full h-full object-cover object-top"
                />
                <button 
                  onClick={() => setSelectedProject(null)}
                  className="absolute top-4 right-4 w-10 h-10 bg-white/20 backdrop-blur-sm rounded-full flex items-center justify-center text-white hover:bg-white/30 transition-colors cursor-pointer"
                >
                  <i className="ri-close-line text-xl"></i>
                </button>
              </div>
              <div className="p-8">
                <div className="flex items-center gap-3 mb-4 flex-wrap">
                  <span className="px-4 py-2 bg-[#ff6b4a] text-white text-sm font-medium rounded-full whitespace-nowrap">
                    {projects[selectedProject].company}
                  </span>
                  <span className="text-[#f5f1e8]/70">{projects[selectedProject].period[language]}</span>
                </div>
                <h3 className="text-3xl font-bold text-white mb-4">{projects[selectedProject].title[language]}</h3>
                <div className="flex flex-wrap gap-2 mb-6">
                  {projects[selectedProject].tags.map((tag, tagIndex) => (
                    <span key={tagIndex} className="px-3 py-1 bg-white/10 text-[#f5f1e8]/80 text-sm rounded-md">
                      {tag}
                    </span>
                  ))}
                </div>
                <p className="text-[#f5f1e8]/80 text-lg leading-relaxed">{projects[selectedProject].description[language]}</p>
              </div>
            </div>
          </div>
        )}
      </div>
    </section>
  );
}
